import { render, staticRenderFns } from "./DocumentoNavAberto.vue?vue&type=template&id=3f6db45c&"
import script from "./DocumentoNavAberto.vue?vue&type=script&lang=js&"
export * from "./DocumentoNavAberto.vue?vue&type=script&lang=js&"
import style0 from "./DocumentoNavAberto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports